"use client";

import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material";
import { ReactNode } from "react";

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = createTheme({
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            "&.Mui-checked": {
              color: "#4687c7",
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
          containedPrimary: {
            backgroundColor: "#1b75d2",
            borderRadius: "50px",
          },
          outlinedPrimary: {
            borderColor: "#1b75d2",
            color: "#1b75d2",
            borderRadius: "50px",
            whiteSpace: "nowrap",
            ":hover": {
              backgroundColor: "#1b75d210",
            },
          },
        },
      },
    },
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
